import { CButton, CCol, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { isValidEmail, validarCedula } from './Tools'
import { Icon } from '@iconify/react'
import { CustomSelect } from 'src/security/OTP'
import { RegisterCustomSelect } from './RegisterCustomSelect'
import AxiosManager from 'src/config/axiosManager'
import { provinciasRD } from './RegisterMunicipios'
import validateDate from 'src/reusable/validateDate'
import NumberFormat from 'react-number-format'
import { RegisterStepLeft } from './RegisterStepLeft'

export const RegisterStep4 = ({ DataForm, handleChange, setDataForm, onCancel, onSuccess }) => {
    const [consultando, setConsultando] = useState(false)
    const [criteria, setCriteria] = useState({
        uppercase: false,
        lowercase: false,
        special: false,
        number: false,
    });

    useEffect(() => {
        setCriteria({
            uppercase: /[A-Z]/.test(DataForm.password),
            lowercase: /[a-z]/.test(DataForm.password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(DataForm.password),
            number: /[0-9]/.test(DataForm.password),
        });
    }, [DataForm])
    const consultaRNC = async () => {
        setConsultando(true)
        AxiosManager.get("/rnc", { params: { q: DataForm.rnc } })
            .then(({ data }) => {
                console.log(data)
                setDataForm({
                    ...DataForm,
                    rnc: data.rnc,
                    nombre: data.nombre,
                    nombrecomercial: data.nombre
                });
            })
            .catch(() => { })
            .finally(() => setConsultando(false))
    };

    const validPassword2 =
        DataForm.password === DataForm.password2 || DataForm.password2 === "";

    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="7">
                <div className="text-md-left ">
                    <h3 className="text-primary">
                        Creacion del Usuario Principal.
                    </h3>
                    <p>
                        Agradecemos completar la información solicitada de forma clara, precisa y verídica. Este formulario está dividido en dos secciones: Información de la Cooperativa e Información del Representante. Todos los campos marcados con asterisco (*) son obligatorios.
                    </p>
                    <p></p>
                </div>





                <CFormGroup row>
                    <CCol md="3">
                        <CLabel htmlFor="text-input" className="LoginLabel">
                            Correo
                        </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                        <CInput
                            className="form-control LoginInput2"
                            name="correo"
                            value={DataForm.correo}
                            placeholder="Correo"
                            onChange={handleChange}
                            disabled
                        />
                    </CCol>
                </CFormGroup>
                <CFormGroup row>
                    <CCol md="3">
                        <CLabel htmlFor="text-input" className="LoginLabel">
                            Contraseña
                        </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                        <CInput
                            className="form-control LoginInput2"
                            type="password"
                            placeholder="Contraseña"
                            name="password"
                            value={DataForm.password}
                            onChange={handleChange}
                        />
                    </CCol>
                </CFormGroup>
                <CFormGroup row>
                    <CCol md="3">
                        <CLabel htmlFor="text-input" className="LoginLabel">
                            Confirmar Contraseña
                        </CLabel>
                    </CCol>
                    <CCol xs="12" md="9">
                        <CInput
                            className="form-control LoginInput2"
                            type="password"
                            placeholder="Contraseña"
                            name="password2"
                            value={DataForm.password2}
                            onChange={handleChange}
                            style={{
                                borderColor: validPassword2 ? "" : "red",
                            }}
                        />
                    </CCol>
                </CFormGroup>

                <CFormGroup row>
                    <CCol md="3">
                        <CLabel
                            htmlFor="text-input"
                            className="LoginLabel"
                        ></CLabel>
                    </CCol>
                    <CCol xs="12" md="9" style={{ textAlign: 'start' }}>
                        <div className="form-group">
                            <ul className="password-indicator">
                                <li className={criteria.uppercase ? "valid" : ""}>
                                    Al menos una mayúscula
                                </li>
                                <li className={criteria.lowercase ? "valid" : ""}>
                                    Al menos una minúscula
                                </li>
                                <li className={criteria.special ? "valid" : ""}>
                                    Al menos un carácter especial
                                </li>
                                <li className={criteria.number ? "valid" : ""}>
                                    Al menos un número
                                </li>
                            </ul>
                        </div>
                    </CCol>
                </CFormGroup>



                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: 50 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        <Icon icon="icon-park-twotone:back" width={25} /> Atras
                    </CButton>
                    <CButton
                        type="submit"
                        color="primary"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        disabled={parseInt(DataForm.estado) === 0}
                        onClick={onSuccess}
                    >

                        Siguiente
                        <Icon icon="fluent:presence-available-10-regular" width={25} style={{ marginLeft: 10 }} />
                    </CButton>
                </div>
            </CCol>
        </CRow>
    )
}
